import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { FacturasService } from '../../reembolso/dashboard/components/detalle-tramite/tabs/facturas/facturas.service';
import { ApiBienestarService } from 'projects/bienestar/src/app/service/api-bienestar.service';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-seccion-registro',
  templateUrl: './seccion-registro.component.html',
  styleUrls: ['./seccion-registro.component.scss']
})
export class SeccionRegistroComponent implements OnInit, OnChanges {
  @Input() tramite: any;
  @Input() garantias?: any;

  expanded = false;
  formRegistroSection: FormGroup;

  diasEnfermeriaMax: number = 0;
  diasEnfermeriaAcomulados: number = 0;
  setionEnfermeria: boolean = false;

  sesionesRehabilitacionMax: number = 0;
  sesionesRehabilitacionAcomulados: number = 0;
  setionRehabilitacion: boolean = false;

  serviciosAmbulanciaMax: number = 0;
  serviciosAmbulanciaAcomulados: number = 0;
  setionAmbulancia: boolean = false;

  alaAzul: boolean = false;
  alaAzulPlus: boolean = false;
  talentoSeguro: boolean = false;

  coberturas: any;
  msgModal: string;
  errorMsg: string;

  constructor(
    private fb: FormBuilder,
    public facturasService: FacturasService,
    private apiBienestarService: ApiBienestarService,
    public ngxSmartModalService: NgxSmartModalService,
  ) {
    this.formRegistroSection = this.fb.group({
      diasEnfermeria: [null],
      sesionesRehabilitacion: [null],
      serviciosAmbulancia: [null],
    });
  }

  ngOnInit(): void {
    const { productoPoliza } = this.tramite;
    if (this.garantias) {
      this.coberturas = this.garantias;
    } else {
      this.coberturas = this.facturasService.catalogos.coberturas;
    }

    const alaAzulProductos = new Set([
      'ALA_AZUL',
      'ALA_AZUL_DIDI',
      'ALA_AZUL_CANAL_DIRECTO'
    ]);

    const alaAzulPlusProductos = new Set([
      'ALA_AZUL_PLUS',
      'ALA_AZUL_PLUS_CANAL_DIRECTO'
    ]);

    const talentoSeguroProductos = new Set([
      'TALENTO_SEGURO_GMMC_EXP_GLOBAL',
      'TALENTO_SEGURO_GMMC_EXP_PROPIA'
    ]);

    this.alaAzul = alaAzulProductos.has(productoPoliza);
    this.alaAzulPlus = alaAzulPlusProductos.has(productoPoliza);
    this.talentoSeguro = talentoSeguroProductos.has(productoPoliza);

    const honorariosEnfermero = this.coberturas.some(cobertura => cobertura.codigo === '6671');
    const rehabilitación = this.coberturas.some(cobertura => cobertura.codigo === '6652');
    const ambulancia = this.coberturas.some(cobertura => cobertura.codigo === '6642');

    this.setionEnfermeria = this.seccionActiva(honorariosEnfermero);
    this.setionRehabilitacion = this.seccionActiva(rehabilitación);
    this.setionAmbulancia = this.seccionActiva(ambulancia);

    if(!this.tramite.botonAprobar) {
      const { modulo, id } = this.tramite;
      this.loadServiciosCoberura(modulo, id);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tramite']) {
      if(!this.tramite.botonAprobar) {
        const { modulo, id } = this.tramite;
        this.loadServiciosCoberura(modulo, id);
      }
    }
  }

  private seccionActiva(condicion: boolean): boolean {
    return ( this.alaAzul || this.alaAzulPlus || this.talentoSeguro ) && condicion;
  }

  addValidators(): void {
    const enfermeria = this.formRegistroSection.get('diasEnfermeria');
    const rehabilitacion = this.formRegistroSection.get('sesionesRehabilitacion');
    const ambulacia = this.formRegistroSection.get('serviciosAmbulancia');

    if (this.setionEnfermeria) {
      enfermeria?.setValidators([
        Validators.required,
        this.maxWithAccumulatedValidator(this.diasEnfermeriaMax, this.diasEnfermeriaAcomulados),
      ]);
    } else {
      enfermeria?.clearValidators();
    }

    if (this.setionRehabilitacion) {
      rehabilitacion?.setValidators([
        Validators.required,
        this.maxWithAccumulatedValidator(this.sesionesRehabilitacionMax, this.sesionesRehabilitacionAcomulados),
      ]);
    } else {
      rehabilitacion?.clearValidators();
    }

    if (this.setionAmbulancia) {
      ambulacia?.setValidators([
        Validators.required,
        this.maxWithAccumulatedValidator(this.serviciosAmbulanciaMax, this.serviciosAmbulanciaAcomulados),
      ]);
    } else {
      ambulacia?.clearValidators();
    }

    this.formRegistroSection.updateValueAndValidity();
  }

  loadServiciosCoberura(modulo: string, id: number): void {
    if ( this.setionEnfermeria || this.setionRehabilitacion || this.setionAmbulancia ) {
      this.apiBienestarService.getServiciosCobertura(modulo, id).subscribe((resp: any) => {
        if (this.setionEnfermeria) {
          this.diasEnfermeriaMax = +resp.seccionEnfermeria.diasMaximos || 0;
          this.diasEnfermeriaAcomulados = +resp.seccionEnfermeria.diasAcumulados || 0;
          this.formRegistroSection.patchValue({
            diasEnfermeria: resp.seccionEnfermeria.diasSolicitados ?? 0,
          });
        }
        if (this.setionRehabilitacion) {
          this.sesionesRehabilitacionMax = +resp.seccionRehabilitacion.sesionesMaximas || 0;
          this.sesionesRehabilitacionAcomulados = +resp.seccionRehabilitacion.sesionesAcumuladas || 0;
          this.formRegistroSection.patchValue({
            sesionesRehabilitacion: resp.seccionRehabilitacion.sesionesSolicitadas ?? 0,
          });
        }
        if (this.setionAmbulancia) {
          this.serviciosAmbulanciaMax = +resp.seccionAmbulancia.serviciosMaximos || 0;
          this.serviciosAmbulanciaAcomulados = resp.seccionAmbulancia.serviciosAcumulados || 0;
          this.formRegistroSection.patchValue({
            serviciosAmbulancia: resp.seccionAmbulancia.serviciosSolicitados ?? 0,
          });
        }
        this.addValidators();
      }, error => {
        console.error('Error al cargar los servicios de cobertura:', error);
      });
    }
  }

  private maxWithAccumulatedValidator(max: number, accumulated: number): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value ?? 0;
      return (value + accumulated) > max ? { maxWithAccumulated: true } : null;
    };
  }

  get fRegistroSection() {
    return this.formRegistroSection.controls;
  }

  saveRegistroSection() {
    const {diasEnfermeria, sesionesRehabilitacion, serviciosAmbulancia} = this.formRegistroSection.value;

    const body = {
      seccionEnfermeria: {
        diasSolicitados: diasEnfermeria ?? null,
        diasAcumulados: this.diasEnfermeriaAcomulados,
        diasMaximos: this.diasEnfermeriaMax
      },
      seccionRehabilitacion: {
        sesionesSolicitadas: sesionesRehabilitacion ?? null,
        sesionesAcumuladas: this.sesionesRehabilitacionAcomulados,
        sesionesMaximas: this.sesionesRehabilitacionMax
      },
      seccionAmbulancia: {
        serviciosSolicitados: serviciosAmbulancia ?? null,
        serviciosAcumulados: this.serviciosAmbulanciaAcomulados,
        serviciosMaximos: this.serviciosAmbulanciaMax
      }
    };

    this.apiBienestarService.saveServiciosCobertura(this.tramite.modulo, this.tramite.id, body).subscribe(
      (resp) => {
        this.addValidators();
        this.msgModal = resp.message;
        this.openModal('saveServiciosCobertura');
      },
      (error) => {
        console.error('Error al guardar el registro:', error);
        this.errorMsg = error.message;
        this.openModal('errorModal');
      }
    );
  }

  openModal(modal) {
    this.ngxSmartModalService.getModal(modal).open();
  }

  closeModal(modal) {
    this.ngxSmartModalService.getModal(modal).close();
  }

  confirmSave() {
    this.closeModal('saveServiciosCobertura');
  }
}
